export const login = "/login";
export const profile = "/profile";
export const get_user = "/get-user";
export const lucky_draw = "/lucky-draw";
export const user = "/user";

// MasterData
export const master_data_banks = "/master-data/banks";
export const master_data_lucky_draw = "/master-data/lucky-draw";
export const master_data_golf_courses = "/master-data/golf-courses";
export const master_data_controller = "/master-data/controllers";

// Caddy
export const caddy_leave_setup = "/caddy/leave-slots";
export const caddy_search = "/caddy/search";
export const get_all_caddies = "caddy/get-all-caddies";
export const caddy_booking = "/caddy/booking";
export const search_tf_date = "/caddy/search/tf-date";

// Booking
export const booking = "/booking";
export const cancel_job = "/booking/cancel_job";
export const booking_refund = "/booking/refund";
export const booking_refund_list = "/booking/refund_list";
export const booking_create_otp = "/booking/create_otp";
export const booking_get_otp = "/booking/get_otp";
export const booking_verify_otp = "/booking/verify_otp";
export const booking_accept_or_reject_job = "/booking/accept_or_reject_job";

// Payment
export const create_payment = "/payment/create_payment";

// Coupon
export const validate_coupon = "/coupon/validate";
export const remove_coupon = "/coupon/remove";

// Golfer
export const favorite = "/favorite";
export const review = "/review";

// Tip Offer ("Book me a caddie")
export const tip_offers = "/tip-offers";
export const tip_offer_applicants = "applicants";
export const tip_offer_apply = "apply";
export const tip_offer_select = "select";
export const tip_offer_cancel = "cancel";
